import React from "react";
import PropTypes from "prop-types";

const PageHeader = props => (
  <div className="fable:pb-4">
    <div className="cb-c-page-header__description">
      <div className="fable:text-3xl fable:font-bold">{props.description}</div>
    </div>
    {props.subtitle && (
      <div className="cb-c-page-header__subtitle">
        <div className="fable:text-base">{props.subtitle}</div>
      </div>
    )}
  </div>
);

PageHeader.propTypes = {
  description: PropTypes.string,
  subtitle: PropTypes.string
};

export default PageHeader;
